<template>
  <div class="card border-warning shadow-sm mb-4">
    <div class="card-header bg-warning-subtle">
        <div>
            <h5 class="mb-1"><i class="ri-error-warning-line align-bottom text-warning me-2"></i> Before You Apply</h5>
            <p class="text-muted mb-0">
                Please complete the required sections of your profile before submitting your application. Missing compulsory information may prevent your application from being processed.
            </p>
        </div>
    </div>

    <div class="card-body">
        <div class="list-group list-group-flush">
            <div class="list-group-item px-0 d-flex justify-content-between align-items-center">
                <div>
                    <h6 class="mb-1">Educational Qualifications</h6>
                    <small class="text-muted">Institution, Qualification, Course, Class/Grade, Certificate Upload</small>
                </div>
                <div class="text-end">
                    <span class="badge bg-danger-subtle text-danger mb-2">Required</span><br>
                    <router-link to="/career-profile?tab=2" class="btn btn-sm btn-outline-primary">
                        Add
                    </router-link>
                </div>
            </div>

            <div class="list-group-item px-0 d-flex justify-content-between align-items-center">
                <div>
                    <h6 class="mb-1">Employment History</h6>
                    <small class="text-muted">Employer, Position, Appointment, Responsibilities</small>
                </div>
                <div class="text-end">
                    <span class="badge bg-danger-subtle text-danger mb-2">Required</span><br>
                    <router-link to="/career-profile?tab=5" class="btn btn-sm btn-outline-primary">
                        Add
                    </router-link>
                </div>
            </div>

            <div class="list-group-item px-0 d-flex justify-content-between align-items-center">
                <div>
                    <h6 class="mb-1">Teaching Experience</h6>
                    <small class="text-muted">Courses Taught, Level, Students Supervised</small>
                </div>
                <div class="text-end">
                    <span class="badge bg-info-subtle text-info mb-2">Optional</span><br>
                    <router-link to="/career-profile?tab=5" class="btn btn-sm btn-outline-primary">
                        Add
                    </router-link>
                </div>
            </div>

            <div class="list-group-item px-0 d-flex justify-content-between align-items-center">
                <div>
                    <h6 class="mb-1">Research Profile & Metrics</h6>
                    <small class="text-muted">Specialization, ORCID, Research Metrics, Awards</small>
                </div>
                <div class="text-end">
                    <span class="badge bg-info-subtle text-info mb-2">Optional</span><br>
                    <router-link to="/career-profile?tab=3" class="btn btn-sm btn-outline-primary">
                        Add
                    </router-link>
                </div>
            </div>

            <div class="list-group-item px-0 d-flex justify-content-between align-items-center">
                <div>
                    <h6 class="mb-1">Publications</h6>
                    <small class="text-muted">Journal Articles, Books, Conference Proceedings, PDF Uploads</small>
                </div>
                <div class="text-end">
                    <span class="badge bg-info-subtle text-info mb-2">Optional</span><br>
                    <router-link to="/career-profile?tab=3" class="btn btn-sm btn-outline-primary">
                        Add
                    </router-link>
                </div>
            </div>

            <div class="list-group-item px-0 d-flex justify-content-between align-items-center">
                <div>
                    <h6 class="mb-1">Administrative Experience</h6>
                    <small class="text-muted">Office Held, Institution, Responsibilities</small>
                </div>
                <div class="text-end">
                    <span class="badge bg-info-subtle text-info mb-2">Optional</span><br>
                    <router-link to="/career-profile?tab=5" class="btn btn-sm btn-outline-primary">
                        Add
                    </router-link>
                </div>
            </div>

            <div class="list-group-item px-0 d-flex justify-content-between align-items-center">
                <div>
                    <h6 class="mb-1">Professional Memberships</h6>
                    <small class="text-muted">Professional Body, Membership Grade, Number</small>
                </div>
                <div class="text-end">
                    <span class="badge bg-info-subtle text-info mb-2">Optional</span><br>
                    <router-link to="/career-profile?tab=3" class="btn btn-sm btn-outline-primary">
                        Add
                    </router-link>
                </div>
            </div>
            <div class="list-group-item px-0 d-flex justify-content-between align-items-center">
                <div>
                    <h6 class="mb-1">Referees</h6>
                    <small class="text-muted">Name, Institution, Position, Email, Telephone</small>
                </div>
                <div class="text-end">
                    <span class="badge bg-danger-subtle text-danger mb-2">Required</span><br>
                    <router-link to="/career-profile?tab=5" class="btn btn-sm btn-outline-primary">
                        Add
                    </router-link>
                </div>
            </div>

            <div class="list-group-item px-0 d-flex justify-content-between align-items-center">
                <div>
                    <h6 class="mb-1">Supporting Documents</h6>
                    <small class="text-muted">Application Letter, CV, Certificates, Passport Photograph, etc.</small>
                </div>
                <div class="text-end">
                    <span class="badge bg-danger-subtle text-danger mb-2">Required</span><br>
                    <router-link to="/career-profile?tab=4" class="btn btn-sm btn-outline-primary">
                        Upload
                    </router-link>
                </div>
            </div>

        </div>

        <div class="alert alert-danger mt-4 mb-0">
            <i class="ri-alert-line me-1"></i>
            <strong>Important:</strong> You should complete all <strong>Required</strong> sections before submitting your application. Optional sections such as Publications, Research Profile, Teaching Experience and Professional Memberships will strengthen your application where applicable.
        </div>
    </div>
</div>
</template>

<script>
export default {

}
</script>

<style>

</style>